import { toBcsProductKey } from 'state/secondaryMarket/utils';
import type { AppState } from 'state/state.model';
import type { WorkspaceType } from 'state/workspaces/model';
import type { BcsProductKey } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.model';

import { fromSecondaryPostEventsWorkspace, fromSecondaryQuotesWorkspace } from '../selectors';

export function getBcsProductKeyByWorkspace(
  state: AppState,
  workspaceType: WorkspaceType,
  tabId: string,
): BcsProductKey | undefined {
  switch (workspaceType) {
    case 'secondaryMarketQuotes':
      return toBcsProductKey(fromSecondaryQuotesWorkspace.getProductKey(state, tabId));
    case 'secondaryMarketPostEvents':
      return fromSecondaryPostEventsWorkspace.getBcsProductKey(state, tabId);
    default:
      return undefined;
  }
}
